<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  async created(){


  }
}
</script>

<style scoped lang="sass">
  #app
    width: 100%
    height: 100%
    background: #F1F3F3;
</style>
